import {Image} from '@logistics-frontend/blocks/image'
import {tag2url} from '@logistics-frontend/utils'
import React from 'react'

import {NavWidgetConfig} from '../types'

const NAV_SLUG = 'custom_right_chevron'

export const NavWidget = (_props: NavWidgetConfig): React.ReactElement => {
  return <Image height={24} src={tag2url(NAV_SLUG)} />
}
